// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"385":"64a75e3c","447":"fbbaf9ea","641":"fbbaf9ea","740":"007cdd72"}[chunkId] + ".chunk.css";
};